module.exports = "/_next/static/images/f625e75445141e198525d01fb3bdebfb-sanpablo-3-desktop.jpg";